$(document).ready(function () {
  const $btn = $("#btn-generate-description");
  if (!$btn.length) return;

  // Classe original do botão (definida na view)
  const originalClass = $btn.attr("class");
  const originalHtml  = $btn.html();

  $btn.on("click", function () {
    const url  = $btn.data("url");
    const $area = $("#publication_description");

    // Estado de loading — a chamada à IA pode levar alguns segundos
    $btn.prop("disabled", true)
        .attr("class", "btn btn-sm btn-secondary ml-2")
        .html('<i class="fa fa-spinner fa-spin"></i> IA gerando...');

    $.ajax({
      url: url,
      type: "GET",
      dataType: "json",
      timeout: 35000, // 35s para dar margem à OpenAI
      headers: {
        "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
      },
    })
      .done(function (data) {
        $area.val(data.description);

        // Aviso se a IA falhou e usou fallback
        if (data.warning) {
          console.warn("[generate_description] Fallback usado:", data.warning);
        }

        // Feedback de sucesso
        $btn
          .attr("class", "btn btn-sm btn-success ml-2")
          .html('<i class="fa fa-check"></i> Gerado pela IA!');

        setTimeout(function () {
          $btn
            .attr("class", originalClass)
            .html(originalHtml)
            .prop("disabled", false);
        }, 2500);
      })
      .fail(function (xhr, status) {
        const isTimeout = status === "timeout";
        const msg = isTimeout
          ? "A IA demorou muito para responder. Tente novamente."
          : "Erro ao gerar descrição com IA. Tente novamente.";

        alert(msg);
        $btn
          .attr("class", originalClass)
          .html(originalHtml)
          .prop("disabled", false);
      });
  });
});
